const recruitingAiV2 = {
  // The old recruiting agent's product wording (no version in the UI).
  productName: 'AI Search',
  // Shown when a chat turn fails for lack of AI points (V2's own copy of the old page's text).
  insufficientCredits: {
    title: 'AI 积分不足',
    description: '开启新的 Agent 对话需要 20 AI 积分，请先获取更多积分。',
  },
  // The old recruiting agent's bottom input (composer.placeholder / hint) and the toolbar above it
  // (composer.menus / executeSearch / searchVersionConfirm), with the owner's V2 changes: no 更换公司 or
  // Boolean Search, 关键词 is Keyword & Skill, 评分标准 is ICP 画像. Clicking a menu item puts it in the input.
  composer: {
    placeholder: '继续调整搜索策略或输入新的指令...',
    send: '发送',
    hint: 'Enter 发送，Shift + Enter 换行',
    executeSearch: '开始搜索',
    executeDisabledReason: '确认画像并生成搜索策略后即可开始搜索',
    icpProfile: 'ICP 画像',
    searchVersionConfirm: {
      title: '请选择你的领英账号类型',
      options: {
        business: 'LinkedIn（普通账号）',
        sales: '领英销售版(Sales)',
        recruiter: '领英企业招聘版(Recruiter)',
      },
    },
    searchVersionSelected: '当前已选择 {version} 自动化搜索模式',
    salesNavigatorStarted: 'Sales Navigator 搜索已启动，插件会在 LinkedIn 页面自动填充筛选条件。',
    salesNavigatorConnectionLost: '搜索页面已关闭或连接中断，请重新点击开始搜索',
    // Standard LinkedIn (Business): 开始搜索 opens a people-search link in a new tab; no automated sourcing.
    searchVersionSelectedBusiness: '当前已选择 {version}，开始搜索会在新标签页打开 LinkedIn 人员搜索',
    businessSearchOpened: '已在新标签页打开 LinkedIn 人员搜索',
    businessSearchPopupBlocked: '浏览器拦截了新标签页，请点击右侧按钮打开 LinkedIn 人员搜索',
    businessSearchOpenLink: '打开搜索',
    businessSearchLocationsOmitted: '地点未带入链接，请在 LinkedIn 页面里选择地点',
    businessSearchUnavailable: '搜索策略里还没有职位或关键词，暂时无法打开 LinkedIn 人员搜索',
    menus: {
      companies: {
        label: '目标公司',
        items: [
          '只看直接竞品',
          '加中腰部公司',
          '加本地公司',
          '加上游公司',
          '加下游渠道公司',
          '加销售模式趋同公司',
          '加产品类似公司',
          '加相同技术栈公司',
          '加相同行业公司',
          '加相同客户类型公司',
          '加中国关联全球公司',
          '排除某些公司',
        ],
      },
      titles: {
        label: '职位词',
        items: ['收窄核心职位词', '扩展职位词', '加 seniority 变体', '按目标公司生成', '删除不相关职位词'],
      },
      keywords: {
        label: 'Keyword & Skill',
        items: ['只保留核心 keyword', '拓展相关 keyword'],
      },
    },
  },
  // A new conversation's welcome page, from the old recruiting agent's (jobCreate.*); the subtitle and
  // the first card are the owner's V2 wording.
  welcome: {
    title: '{name}，描述你的招聘需求',
    placeholder:
      '例如：「招一位 Senior AI Engineer，3 年以上 LLM / RAG / Agent 经验，上海或远程，英语流利，有开源作品优先」',
    send: '发送',
    capabilitiesLabel: 'EasyHire AI 能力',
    talentRecommendTitle: '人才库即时推荐',
    talentRecommendDesc: '融合 GitHub · X · LinkedIn 等公开数据，秒级返回 AI 人才推荐',
    linkedinSearchTitle: 'LinkedIn 自动搜索',
    linkedinSearchDesc: '插件在 Recruiter 页面自动执行搜索计划，简历回流后会自动评分',
    newBadge: 'NEW',
    example1Label: 'LLM 研究员',
    example1Prompt:
      '招聘资深大模型算法研究员，base 北京，负责预训练与对齐（RLHF / DPO），需有千亿参数模型训练经验，顶会论文优先，目标公司：字节跳动、阿里通义、月之暗面。',
    example2Label: '储能国际销售',
    example2Prompt:
      '招聘储能欧洲销售总监，常驻德国慕尼黑，负责欧洲工商业及电网侧储能项目开发，英语或德语可作为工作语言，8 年以上新能源行业销售经验',
    example3Label: '国际 HR',
    example3Prompt:
      '招聘中级 HRBP，base 阿联酋迪拜，支持中东区域约 300 人团队的招聘、绩效与劳动合规，英语为工作语言，需有中资企业出海 HR 经验。',
  },
  // The voice button (welcome and bottom inputs), copied from the old recruiting agent's (composer.*Voice*).
  voice: {
    start: '语音输入',
    stop: '停止语音输入',
    unsupported: '当前浏览器不支持语音输入',
    permissionDenied: '未获得麦克风权限，无法使用语音输入',
    failed: '语音输入失败，请重试',
    status: {
      idle: '点击麦克风开始语音输入',
      starting: '正在打开麦克风，请开始说话...',
      listening: '正在听你说话...',
      processing: '正在整理语音内容...',
      success: '语音内容已填入输入框',
      empty: '没有听清楚，再说一次试试',
      error: '语音输入异常，请重试',
    },
  },
  chat: {
    searching: '正在搜索...',
    deepSearch: '开启深度搜索',
    searchCompleted: '搜索已完成',
    openSearchPack: '搜索已完成，查看 Pack {pack} 人才列表',
    searchPlatformsIllustration: '公开资料平台 · 示意',
    searchTargetCompanies: '目标公司',
    searchMoreCompanies: '其他目标公司',
    expandMessage: '展开更多',
    collapseMessage: '收起',
    degradedNotice: '这条回复可能不完整，使用前请再确认一下。',
    errorRetry: '出了点问题，请重新发送消息重试。',
    // 管理模式下查看其他用户的对话：只能查看。
    readOnly: '这是其他用户的对话，只能查看，不能发送消息或修改策略',
    // 刷新页面打断了上一轮回复（2026-10-16 兜底方案）。
    interruptedNotice: '上一轮回复被中断了，请重新发送。',
    confirmIcpFailed: '画像确认失败，请重试。',
    // 必须与后端为岗位概述修改保存的历史文案一致（步骤 11 B-2）。
    roleSummaryEdited: '我修改了岗位概述：{text}',
    roleSummaryEditFailed: '岗位概述更新失败，请重试。',
    // Step 20 P19: the small tag above a message saying where it came from (never part of its text).
    source: {
      linkedinFeedback: 'LinkedIn 反馈',
      instantRecommend: '即时推荐',
    },
    // Q10: a turn or a confirm that has waited 20 s.
    longWait: '仍在处理中…',
    // Step 20 P17: what the Agent is doing before its reply text starts (`run.progress` steps).
    progress: {
      received: '正在理解你的需求…',
      profile: '正在整理岗位画像…',
      strategy: '正在生成搜索策略…',
      companies: '正在搜索和更新目标公司…',
      reply: '正在整理回复…',
    },
    initialProfile: {
      intro: '我先理解一下这次需求，并整理岗位画像。',
      steps: { received: '正在识别本轮意图和岗位方向', profile: '正在构建人才画像', strategy: '正在整理搜索条件', reply: '正在整理回复' },
      done: { received: '已收到岗位需求', profile: '人才画像已生成', strategy: '搜索条件已整理', reply: '回复已准备好' },
      details: { received: '正在检查岗位、地点及招聘条件是否完整', profile: '正在整理必备条件、加分条件与不匹配信号', strategy: '正在整理职位词、关键词与目标公司', companies: '正在搜索和更新目标公司', reply: '正在整理本轮结论与需要确认的信息' },
      strategyCounts: '职位词：{titles} · 关键词：{keywords} · 目标公司：{companies}',
    },
  },
  // Step 20: a new-format reply's changes card, clarification and action buttons.
  turn: {
    changesTitle: '本轮更新：',
    changeTargets: {
      icp: '画像',
      strategy: '搜索策略',
    },
    fieldSeparator: '、',
    actionLabels: {
      confirm_icp: '确认画像',
      open_icp: '打开画像',
      open_strategy: '打开策略',
      instant_recommend: '即时推荐',
      linkedin_search: '开始搜索',
    },
  },
  // Step 20 §2 / §3: the confirm card (three skippable fields) and what happens after the confirm.
  confirm: {
    title: '确认人才画像',
    optionalHint: '以下三项均可跳过，留空直接确认即可',
    skippable: '可跳过',
    fields: {
      hiring_company: '招聘公司',
      industry: '所属行业',
      business_type: '业务类型',
    },
    preparing: '正在生成搜索策略…',
    confirmDirectly: '直接确认',
    retry: '重试',
    strategyReady: '搜索策略已生成',
    strategyFailed: '搜索策略生成失败：{reason}',
    preparationErrors: {
      timeout: '生成超时',
      failed: '生成出错',
      incomplete: '策略信息还不完整',
      unknown: '原因未知',
    },
    recommend: {
      starting: '正在开始即时推荐…',
      started: '即时推荐已开始',
      conflict: '搜索策略已更新，已载入最新版本，请确认后再点「即时推荐」',
      not_started: '即时推荐未能开始，可在搜索策略卡片上点「即时推荐」重试',
    },
    errors: {
      invalid_optional_context: '补充信息的格式不正确，请修改后再确认',
      structured_icp_required: '这是较早生成的画像，无法补充这三项信息，可以直接确认',
      icp_version_not_found: '该画像版本已不存在，已载入当前画像，请继续对话生成新的画像后再确认',
      icp_version_conflict: '画像已更新，请确认最新画像',
      retryable: '确认请求没有完成，可能已经提交，可以重试（内容不变）',
      failed: '画像确认失败，请重试',
    },
  },
  suggestion: {
    fallbackLabels: {
      revise_icp: '还需要调整',
    },
  },
  icp: {
    title: '人才画像',
    confirmed: '已确认',
    waiting: '待确认',
    viewDetails: '查看全部',
    legendConfirmed: '确认',
    updating: '更新中…',
    updated: '已更新',
    version: '版本 {version}',
    updatedAt: '{time}更新',
    justNow: '刚刚',
    notMentioned: '未提及',
    origin: {
      confirmed: '已确认',
      inferred: '推断',
    },
    empty: '暂无画像',
    noMustHave: '暂无',
    noMismatch: '暂无',
    fields: {
      hiringCompany: '招聘公司',
      roleOverview: '岗位概述',
      mustHave: '必备条件',
      mismatch: '不匹配信号',
      title: '职位',
      preferred: '加分条件',
      typicalSources: '人才来源',
      searchSuggestions: '搜索建议',
      industry: '所属行业',
      businessType: '业务类型',
    },
  },
  filter: {
    title: '搜索策略',
    viewDetails: '查看全部',
    started: '已开始',
    recommendButton: '即时推荐',
    recommendRunning: '搜索中…',
    linkedinButton: '开始搜索',
    readonlyNote: '「查看全部」更新策略，或继续在对话中说明，可直接点击【开始搜索】 进行下一轮',
    fields: {
      companies: '目标公司',
      excludedCompanies: '排除公司',
      jobTitles: '职位词',
      keywords: '关键词',
    },
  },
  strategy: {
    sections: {
      core: '搜索核心',
      companies: '公司',
      background: '候选人背景',
      education: '教育与其他',
      advanced: '高级筛选',
    },
    fields: {
      titles: '职位词',
      coreKeywords: 'Keyword & Skill',
      locations: '地点',
      companies: '目标公司',
      excludedCompanies: '排除公司',
      industries: '行业',
      jobFunctions: '职能',
      seniority: '职级',
      languages: '语言',
      yearsOfExp: '工作年限',
      currentRoleYears: '当前岗位年限',
      jobHop: '跳槽频率',
      schools: '学校',
      majors: '专业',
      degrees: '学历',
      isChinese: '华人',
      chinaExperience: '中资企业任职经历',
      // Fields with no drawer control: named only where a change lists them.
      narrowKeywords: '加分关键词',
      excludedKeywords: '排除关键词',
      excludedTitles: '排除职位词',
      workArrangement: '办公方式',
      languagePriority: '语言要求优先级',
      ageRange: '年龄',
      workLocationScope: '地点匹配范围',
      companyRecommendations: '公司推荐理由',
      companyGroupScope: '集团匹配范围',
    },
    locationScopeLabel: '匹配',
    locationScope: {
      current: '当前工作地点',
      past: '过往工作地点',
    },
    companyScopeLabel: '目标公司匹配范围',
    companyScope: {
      any: '当前及以往经历',
      current: '当前就职',
      past: '以往经历',
    },
    jobHop: {
      noLimit: '不限',
      threeYears: '近 3 年最多 2 段工作经历',
      fiveYears: '近 5 年最多 3 段工作经历',
      lastTwoEachTwoYears: '最近 2 段工作经历均至少 2 年',
    },
    chinaExperience: {
      any: '不限',
      yes: '有中资企业任职经历',
      no: '无中资企业任职经历',
      noHint: '仅匹配明确标记为无的候选人',
    },
    showReasons: '展开原因',
    hideReasons: '收起原因',
    noReason: '暂无推荐理由',
    manualAdded: '手动添加',
    expandMore: '+{count} 展开',
    collapse: '收起',
    unlimited: '不限',
    changedCount: '已修改 {count} 处',
    undo: '撤销',
    saveStatus: {
      saving: '保存中…',
      recognizingRegions: '正在识别地区…',
      saved: '已保存',
      regionUnrecognized: '这个地区没能识别，请改写成具体国家',
      failed: '保存失败',
      rejected: '保存失败，内容未通过校验',
      invalidDraft: '有内容未通过校验，修正后才会保存',
      retry: '重试',
      conflict: '策略已被更新，已载入最新版本，可重新修改',
      dismiss: '知道了',
      blocked: '搜索策略尚未保存成功，请在搜索策略详情中处理后再开始搜索',
      searchVersionConflict: '搜索策略已更新，已载入最新版本，请确认后再搜索',
      searchVersionReloadFailed: '搜索策略已更新，但最新版本载入失败，请刷新页面后再搜索',
    },
    capHint: '最多 {max} 个',
    capExceeded: '最多 {max} 个，请删除多余项',
    // 名单字段逐个输入（负责人 2026-10-28）：粘贴先确认再添加，逗号由用户决定是否拆开。
    tagInput: {
      reviewHint: '粘贴的内容拆成了以下几项，确认后添加：',
      addAll: '全部添加',
      cancel: '取消',
      splitByComma: '按逗号拆开',
      unmatched: '未匹配',
      overCap: '{count} 项超过上限（最多 {max} 个），未添加',
      ambiguous: '有多个同名地点，请选择一个',
      levels: { city: '城市', region: '省/州', country: '国家', area: '区域', region_group: '地区', metro: '都市圈' },
    },
    options: {
      loading: '选项加载中…',
      failed: '选项加载失败，暂不可修改',
      unavailable: '暂无可选项，暂不可修改',
      retry: '重试',
      nonStandard: '非标准值',
      invalidOption: '含非标准值，删除后才能保存',
    },
    removeItem: '删除 {item}',
    addField: '添加{field}',
    selectField: '选择{field}',
    addPlaceholder: '+ 添加',
    selectPlaceholder: '+ 选择',
    emptyPlaceholder: '{empty} · {action}',
    placeholders: {
      titles: '+ 添加职位词，回车确认',
      coreKeywords: '+ 添加关键词或技能',
      locations: '+ 添加地点',
      companies: '+ 添加公司',
      excludedCompanies: '+ 添加要排除的公司',
    },
    rangeMin: '{field}最低',
    rangeMax: '{field}最高',
    rangeTo: '至',
    rangeUnit: '年',
    rangeAtLeast: '{min} 年以上',
    rangeAtMost: '最多 {max} 年',
    rangeErrors: {
      reversedRange: '最低年限不能大于最高年限',
      invalidNumber: '请输入 0 或正整数',
    },
  },
  drawer: {
    close: '关闭',
  },
  radar: {
    noResultsNotice: '「AI持续寻访」，平台将持续在全球公开数据中为您寻访合适人才，发现匹配后及时通知您；也可以启动 LinkedIn 搜索功能搜索匹配人才。',
    searchTimeoutNotice: '正在努力寻访中，已为你保留目前找到的 {count} 人，可以开启深度搜索。',
    deepSearchTimeoutNotice: '深度搜索已结束，已为你保留目前找到的 {count} 人。',
    nextBatch: '查看更多人才',
    nextBatchHint: '继续为你寻访下一批人才',
    nextBatchFailed: '暂时无法寻访下一批人才，请稍后再试',
    candidatePacks: '人才批次',
    selectPack: '选择人才批次',
    reviewTabsLabel: '人才审阅',
    reviewTabs: { all: '全部', unreviewed: '未审阅', yes: '认可', no: '已淘汰' },
    openPanel: '展开推荐人才',
    closePanel: '收起推荐人才',
    resizePanel: '调整推荐人才侧栏宽度',
    status: { idle: '还没有开始', running: '检索中', completed: '已完成', cancelled: '已取消', failed: '检索失败' },
    relaxedCount: '已放宽 {count} 次',
    // C1 / C2: people meeting the hard conditions, and how many are shown.
    matchTotal: '潜在人才库 {count} 人',
    matchTotalCapped: '潜在人才库 1k+ 人',
    shownCount: '已推荐 {count} 人',
    stop: '停止',
    tiles: { relatedTerms: '关联词', recalled: '召回', found: '推荐人才 ›', highMatch: '高匹配 ›' },
    stages: { plan: '规划', recall: '召回', assess: '评估' },
    stagesLabel: '检索进度',
    counterPending: '统计中',
    loading: '正在人才库中检索…',
    failure: {
      timeout: '检索超时，没有完成。',
      stream_ended: '检索中断了，没有拿到完整结果。',
      generic: '检索没有完成。',
      cancelled: '已停止这次推荐。',
    },
    retry: '重试',
    recommendAgain: '重新推荐',
    emptyList: '还没有推荐结果',
    allAddedToJob: '这一批人才已全部加入岗位',
    emptyIntro: '还没有开始推荐',
    emptyIntroHint: '确认人才画像和搜索策略后点「即时推荐」。会按搜索策略在人才库里检索，过程和结果显示在这里。',
    recommendButton: '即时推荐',
    viewGraph: '关系图',
    viewList: '列表',
    filterAll: '全部',
    filterHigh: '高匹配',
  },
  candidate: {
    expand: '展开人才信息',
    collapse: '收起人才信息',
    previewRole: '职位',
    previewCompany: '最近公司',
    detailFields: {
      name: '姓名',
      full_name: '姓名',
      candidate_name: '候选人',
      title: '职位',
      headline: '标题',
      current_title: '当前职位',
      current_company: '当前公司',
      company: '公司',
      organization: '组织',
      location: '地点',
      city: '城市',
      country: '国家',
      summary: '摘要',
      bio: '简介',
      description: '描述',
      profile_url: '档案链接',
      url: '链接',
      linkedin_url: 'LinkedIn',
      start_date: '开始时间',
      end_date: '结束时间',
      school: '学校',
      degree: '学历',
      major: '专业',
      email: '邮箱',
      phone: '电话',
      source: '来源',
      candidate_id: '候选人ID',
      role: '当前角色',
      score: '匹配分',
      match_level: '匹配层级',
      work_experience: '累计工作年限',
      work_experience_no_gap: '连续工作年限',
      birth_year: '出生年份',
      is_chinese: '中国候选人',
      working_status: '在职状态',
      function_id: '职能ID',
      organization_id: '组织ID',
      institution_id: '院校ID',
      major_id: '专业ID',
      employment_type: '雇佣类型',
      location_type: '工作方式',
      work: '工作记录',
      project: '项目证据',
      publicSource: '公开来源',
      open: '打开',
      present: '至今',
    },
    unnamed: '未命名候选人',
    present: '至今',
    companyEvidence: '目标公司',
    add: '加入岗位',
    added: '已加入',
    addedToJob: '已加入岗位',
    selectCandidate: '选择人才 {name}',
    aiMatchLockedTitle: '还有 {count} 位潜在人才，等待你发现',
    aiMatchLockedDescription: '当前 AI 积分已用完，补充积分即可继续解锁人才资料，不错过更多合适人选。',
    aiMatchUpgrade: '继续解锁人才',
    aiMatchUnlocked: '已解锁 {count} 位人才',
    aiMatchUnlockedPartial: '已解锁 {count} 位人才；积分不足，仍有 {locked} 位未解锁',
    selectAll: '全选当前列表',
    selectedCount: '已选 {count} 人',
    bulkAdd: '批量加入岗位',
    bulkBinding: '加入中…',
    bulkSuccess: '已将 {count} 人加入岗位',
    bulkPartial: '已加入 {success} 人，{failed} 人加入失败，可重试',
    rejectedBindHint: '请先撤销淘汰，再加入岗位。',
    noRunHint: '这是早期的搜索结果，重新搜索后才能加入岗位',
    bindSuccess: '已加入岗位人才',
    viewJobTalent: '去查看',
    bindFailed: '加入岗位失败',
    viewDetail: '查看详情',
    detailTitle: '候选人详情',
    socialProfiles: '候选人社交主页',
    // C3: one icon per profile link on the candidate card; unverified ones carry profileLinkUnverified.
    profileLinks: {
      linkedin: 'LinkedIn',
      github: 'GitHub',
      website: '个人网站',
      orcid: 'ORCID',
      google_scholar: 'Google Scholar',
      dblp: 'DBLP',
      semantic_scholar: 'Semantic Scholar',
      twitter: 'X（Twitter）',
      other: '其他主页',
    },
    profileLinkAria: '在新标签页打开 {name} 的 {platform}',
    profileLinkUnverified: '候选人资料中的链接，未核实是否本人',
    summary: '档案摘要',
    // Owner decision 2026-10-29: the one-line reason the card shows; the chips collapse under 匹配依据.
    matchReason: '匹配原因',
    evidence: '匹配依据',
    // Owner decision 2026-10-28: the search's evidence codes as Chinese chips (evidenceLabels.ts).
    evidenceLabels: {
      academicSource: '职能与学术成果相符',
      titleSameSubFunction: '同一细分职能',
      titleSameFunction: '同一职能',
      functionMatch: '职能匹配',
      seniorityMatch: '职级匹配',
      seniorityHeldEarlier: '曾任该职级',
      industryCurrentCompany: '现任公司行业匹配',
      industryPastCompany: '过往公司行业匹配',
      industryParentCurrentCompany: '现任公司属同一行业大类',
      industryParentPastCompany: '过往公司属同一行业大类',
      skillGroupsFull: '技能要求全部满足',
      skill: '技能：{name}',
    },
    publications: '论文',
    projects: '项目',
    projectStars: '{count} 星标',
    openInNewTab: '在新标签页打开 {name}',
    latestBackground: '最近经历',
    resumeUnavailable: {
      noRun: '这是早期的搜索结果，无法加载完整简历，重新搜索后可查看。',
      notFound: '该推荐结果已失效，无法加载完整简历，请重新搜索。',
      failed: '无法加载完整简历，请稍后重试。',
    },
    get: '获取',
    unlockContact: '解锁联系方式',
    unlockContactWithCost: '消耗 {count} 联系积分解锁联系方式',
    unlockContactSuccess: '联系方式已解锁',
    unlockContactFailed: '解锁联系方式失败',
    unlockContactInsufficient: '联系积分不足，请购买或升级后解锁',
    noUnlockableContact: '暂无该候选人的联系方式',
    resultExpired: '该推荐结果已失效，请重新搜索',
  },
  feedback: {
    approve: '认可',
    reject: '淘汰',
    whyApprove: '为什么认可？',
    whyReject: '为什么淘汰？',
    boundRejectHint: '仅淘汰本次推荐，不会移除已加入的岗位人才。',
    notePlaceholder: '选填备注',
    cancel: '取消',
    confirmApprove: '确认认可',
    confirmReject: '确认淘汰',
    approved: '已认可',
    rejected: '已淘汰',
    undo: '撤销',
    reasonCompanyFit: '公司背景对口',
    reasonMultiUnit: '多店 / 区域管理',
    reasonRelevantExperience: '有加盟经验',
    reasonBilingual: '中英双语',
    reasonRightSeniority: '年限合适',
    reasonWrongSeniority: '年限不符',
    reasonWrongIndustry: '行业不对口',
    reasonNoRelevantExperience: '没有相关经验',
    reasonTooJunior: '职级偏低',
    reasonTooFar: '地点太远',
  },
  proposal: {
    progressIntro: '正在更新搜索策略。',
    progressLabel: '正在保存已确认的调整',
    progressDetail: '保存完成后展示最新策略',
    confirmTitle: '是否调整这次搜索策略？',
    acceptChanges: '采用以下调整建议',
    confirm: '确定',
    otherLabel: '补充意见',
    otherPlaceholder: '补充您希望保留或调整的条件…',
    retryOther: '重新整理建议',
    updated: '策略已更新',
    updateDetails: '策略调整详情',
    retrySave: '重试保存',
    apply: '按此修改并重新搜索',
    applying: '正在保存…',
    applied: '已采纳',
    appliedVersion: '已采纳 · 策略版本 {version}',
    loading: '正在加载修改详情…',
    unavailable: '修改详情加载失败，暂时无法保存',
    noChanges: '没有实际修改，策略保持不变',
    mismatch: '修改详情不一致，暂时无法保存',
    stale: '策略已变化，此建议不再适用',
    gone: '该建议已不存在',
    toast: {
      versionConflict: '策略已变化，已载入最新策略，此建议不再适用',
      searchNotStarted: '策略已保存，但 LinkedIn 搜索未启动：{reason}',
      operationConflict: '策略保存未成功，请重试',
      notFound: '该建议已不存在',
      rejected: '无法保存本次策略修改',
      applyFailed: '策略保存失败，网络或服务异常，请重试',
    },
    searchReasons: {
      versionConflict: '策略又有更新，已载入最新策略',
      cancelled: '已取消',
      busy: '已有 LinkedIn 搜索正在启动',
    },
  },
  agentQuestion: {
    label: '问题',
    count: '{current} / {total}',
    previous: '返回上一题',
    confirmAnswer: '确认回答',
    later: '稍后回答',
    options: '答案选项',
    supplementLabel: '补充回答',
    supplementPlaceholder: '或补充你的要求…',
    confirm: '确认',
    submitting: '正在提交…',
    retry: '重试',
    failed: '提交没有成功，答案已保留，可以重试',
    deferred: '可以稍后补充，当前搜索条件保持不变。',
    deferredClarify: '可以稍后再回答。',
    resume: '继续回答',
    summary: {
      field: '{label}：{change}',
      remove: '去掉 {values}',
      add: '加入 {values}',
      changeTo: '改为 {value}',
      moreCompanies: '{values} 等 {count} 家',
      moreItems: '{values} 等 {count} 项',
      listSeparator: '、',
      partSeparator: '，',
      fieldSeparator: '；',
    },
    modify: {
      question: '{changes}；其他条件不变。按这个建议修改搜索策略吗？',
      draftQuestion: '{changes}；其他条件不变。按这个修改草案修改搜索策略吗？',
      accept: '按此修改',
      revise: '我想换个改法',
    },
    batch: {
      question: '分批寻访，按{field}：先找 {first}，之后依次是 {rest}。可以先找这部分的人才吗？',
      questionSingle: '分批寻访，按{field}：先找 {first}。可以先找这部分的人才吗？',
      summary: '分批寻访，按{field}：先找 {first}',
      accept: '可以，先找这部分',
      revise: '换个顺序或分法',
    },
    continue: {
      question: '策略不变，从上一轮停下的位置接着往后找。按当前策略继续寻访吗？',
      accept: '按当前策略继续寻访',
      revise: '我想调整策略',
    },
  },
  linkedin: {
    title: 'LinkedIn 自动搜索',
    startButton: '立刻搜索',
    runningButton: '正在启动搜索…',
    retryButton: '再次搜索',
    extensionConnected: '插件已连接',
    extensionChecking: '正在检查插件…',
    extensionMissing: 'EasyHire 插件未连接。',
    salesFeedbackPluginUpdateRequired: '请更新 EasyHire 插件，以支持 Sales Navigator 反馈和工作年限多选。',
    installExtension: '安装插件',
    recheck: '重新检查',
    missingJob: '请先创建招聘项目，再启动 LinkedIn 搜索。',
    confirmTitle: '启动 LinkedIn 搜索',
    confirmMessage: '创建标签“{tagName}”并在 LinkedIn 收集候选人？',
    confirmButton: '开始搜索',
    started: '搜索已启动，插件将在 LinkedIn 页面收集候选人。',
    failedDetail: '启动 LinkedIn 搜索失败：{message}',
    connectionLost: 'LinkedIn 页面已关闭或插件连接中断，搜索可能仍在进行；再次点击搜索可选择继续等待或放弃。',
    pluginNoAnswer: '插件未及时确认是否收到搜索任务，搜索可能仍在进行；再次点击搜索可选择继续等待或放弃。',
    uncertain: {
      message: '上次搜索可能仍在进行',
      continueWaiting: '继续等待',
      abandonAndSearch: '放弃并重新搜索',
    },
    abandonConfirm: {
      research: {
        title: '放弃并重新搜索',
        message: '放弃后，上一次 LinkedIn 搜索不再更新，也不会生成 Agent 回复；插件若仍在 LinkedIn 页面运行，请在插件中手动停止。随后将按当前策略创建标签“{tagName}”并重新搜索。',
        button: '放弃并重新搜索',
      },
      stop: {
        title: '放弃这次搜索',
        message: '放弃后，这次 LinkedIn 搜索不再更新，也不会生成 Agent 回复；插件若仍在 LinkedIn 页面运行，请在插件中手动停止。',
        button: '放弃这次搜索',
      },
    },
    feedback: {
      running: 'LinkedIn 搜索进行中',
      analysing: '搜索结果已提交，Agent 正在分析',
      recoverable: '回复待恢复',
      saving: '分析已生成，正在保存反馈',
      failed: '反馈未能保存',
      authorization: '请登录后继续接收反馈',
      retry: '重试',
      accepted: '已受理 {count} 人',
      stoppedByUser: '已手动停止，数据不完整',
      abandoned: '已放弃',
      stale: '已有 {minutes} 分钟没有收到新数据',
      abandon: '放弃这次搜索',
      abandonFailed: '未能放弃这次搜索，请稍后重试',
    },
    rejected: {
      searchActive: '该岗位已有进行中的 LinkedIn 搜索',
      runEnded: '这次 LinkedIn 搜索已结束，再次点击将开始新的搜索',
      missingJobTitle: '搜索策略缺少职位名称',
      versionUnavailable: '还没有可用的搜索策略',
      operationConflict: 'LinkedIn 搜索未能启动，请重新点击搜索',
      startUnavailable: 'LinkedIn 搜索未能启动，请稍后重试',
      startNetwork: 'LinkedIn 搜索未能启动，网络异常，请重试',
      legacyActive: '存在历史 LinkedIn 任务需要处理',
      abandonFailed: '未能放弃上一次 LinkedIn 搜索，请稍后重试',
      sourceAlreadyContinued: '这一轮已经按当前策略继续寻访过了',
      continueUnavailable: '无法从上一轮停下的位置继续寻访，请调整策略后重新搜索',
    },
  },
}

export default recruitingAiV2
